import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ORDER_ONLINE_URL, DELIVERY_URL, HERO_IMAGE_URL, cdnImg } from "../lib/data";

// Hero uses the original clean monogram artwork (separate from the
// new textured header monogram swapped into MONOGRAM_URL).
const HERO_MONOGRAM_URL =
    "https://customer-assets.emergentagent.com/job_gaffer-albany/artifacts/r0865oke_image.png";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-28 md:pt-32 pb-16 md:pb-24"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    <div className="lg:col-span-6 lg:pr-6">
                        <motion.img
                            src={HERO_MONOGRAM_URL}
                            alt="The Gaffer monogram"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1] }}
                            style={{ mixBlendMode: "multiply" }}
                            className="block w-44 md:w-40 lg:w-48 mb-7 md:mb-8 select-none pointer-events-none"
                        />

                        <motion.h1
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.1,
                                duration: 0.9,
                                ease: [0.19, 1, 0.22, 1],
                            }}
                            className="font-display uppercase text-[#121212] leading-[0.9] text-[clamp(4rem,15vw,7rem)] md:text-[clamp(3rem,8vw,7rem)]"
                        >
                            Burgers
                            <br />
                            &amp;
                            <br />
                            <span className="text-[#EB4A18]">
                                Shakes.
                            </span>
                        </motion.h1>

                        <motion.p
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.25,
                                duration: 0.9,
                                ease: [0.19, 1, 0.22, 1],
                            }}
                            className="mt-6 max-w-md text-[#4A4A4A] text-base md:text-lg leading-relaxed"
                        >
                            190 York Street, Albany WA. Fully licensed bar.
                            <br />
                            <span className="whitespace-nowrap">
                                Open Mon — Sat, 11 till 8.
                            </span>
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.35,
                                duration: 0.9,
                                ease: [0.19, 1, 0.22, 1],
                            }}
                            className="mt-10 flex flex-wrap items-center gap-4"
                        >
                            <a
                                href={ORDER_ONLINE_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="hero-order-online-btn"
                                className="btn-primary"
                            >
                                Order Pickup
                                <span aria-hidden="true">→</span>
                            </a>
                            <a
                                href={DELIVERY_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="hero-delivery-btn"
                                className="btn-secondary"
                            >
                                Get Delivery
                            </a>
                            <Link
                                to="/menu"
                                data-testid="hero-menu-btn"
                                className="btn-secondary"
                            >
                                See Menu
                            </Link>
                        </motion.div>
                    </div>

                    <motion.figure
                        initial={{ opacity: 0, scale: 1.02 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                            delay: 0.2,
                            duration: 1.1,
                            ease: [0.19, 1, 0.22, 1],
                        }}
                        className="lg:col-span-6 relative"
                    >
                        <img
                            src={cdnImg(HERO_IMAGE_URL, 1400)}
                            alt="The Gaffer signature smashed burgers"
                            loading="eager"
                            fetchpriority="high"
                            decoding="async"
                            className="w-full h-auto object-cover aspect-square"
                        />
                    </motion.figure>
                </div>
            </div>
        </section>
    );
}
